/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaywed3Inputs */

const en_placewebdaywed3 = /** @type {(inputs: Placewebdaywed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wed`)
};

const de_placewebdaywed3 = /** @type {(inputs: Placewebdaywed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi`)
};

/**
* | output |
* | --- |
* | "Wed" |
*
* @param {Placewebdaywed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaywed3 = /** @type {((inputs?: Placewebdaywed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaywed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaywed3(inputs)
	return de_placewebdaywed3(inputs)
});
export { placewebdaywed3 as "placeWebDayWed" }